import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const names = ['María Laura G.', 'Valentina R.', 'Carolina M.', 'Lucía F.', 'Sofía B.', 'Florencia P.', 'Camila T.', 'Romina S.', 'Natalia V.', 'Daniela C.', 'Martín A.', 'Diego H.', 'Sebastián L.', 'Nicolás E.', 'Andrés O.', 'Jimena R.', 'Paola M.', 'Verónica D.', 'Claudia N.', 'Marcela F.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Resistencia', 'Posadas', 'Bahía Blanca', 'Paraná'];
const combos = [{
  name: 'Combo 2 — Profesional',
  color: '#d4af37'
}, {
  name: 'Combo 3 — Maestría',
  color: '#a78bfa'
}];
const timeAgo = ['hace 2 minutos', 'hace 4 minutos', 'hace 7 minutos', 'hace 1 minuto', 'hace 5 minutos', 'hace 3 minutos'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Purchase {
  id: number;
  name: string;
  city: string;
  combo: {
    name: string;
    color: string;
  };
  time: string;
}
export function SocialProofPopup() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  const [visible, setVisible] = useState(false);
  const [counter, setCounter] = useState(0);
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      showNext();
    }, 4000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Auto-hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, counter]);
  useEffect(() => {
    if (visible) return;
    if (counter === 0) return;
    // Show next after 8 seconds gap
    const nextTimer = setTimeout(() => {
      showNext();
    }, 8000);
    return () => clearTimeout(nextTimer);
  }, [visible, counter]);
  function showNext() {
    setCurrent({
      id: Date.now(),
      name: getRandom(names),
      city: getRandom(cities),
      combo: getRandom(combos),
      time: getRandom(timeAgo)
    });
    setVisible(true);
    setCounter(c => c + 1);
  }
  return <div className="fixed bottom-6 left-4 z-50 max-w-xs w-full sm:w-80 pointer-events-none" data-id="element-260">
      <AnimatePresence data-id="element-261">
        {visible && current && <motion.div key={current.id} initial={{
        opacity: 0,
        x: -80,
        y: 0
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -80
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 28
      }} className="pointer-events-auto bg-[#1e1254] border border-purple-700/60 rounded-xl shadow-2xl p-4 flex items-start gap-3" data-id="element-262">
            {/* Avatar */}
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-md" data-id="element-263">
              <ShoppingBag className="w-5 h-5 text-white" data-id="element-264" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-265">
              <p className="text-white text-sm font-semibold leading-tight truncate" data-id="element-266">
                {current.name}
              </p>
              <p className="text-purple-300 text-xs mt-0.5" data-id="element-267">
                {current.city}, Argentina
              </p>
              <p className="text-xs mt-1" data-id="element-268">
                <span className="text-gray-300" data-id="element-269">acaba de comprar </span>
                <span className="font-bold" style={{
              color: current.combo.color
            }} data-id="element-270">
                  {current.combo.name}
                </span>
              </p>
              <p className="text-purple-500 text-xs mt-1" data-id="element-271">{current.time}</p>
            </div>

            {/* Close */}
            <button onClick={() => setVisible(false)} className="flex-shrink-0 text-purple-500 hover:text-white transition-colors mt-0.5" data-id="element-272">
              <X className="w-4 h-4" data-id="element-273" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}